import { XA_PAUSE_REFRESHING } from '../../actions/xAgent';

const INITIAL_STATE = {
  pause: false,
};

export default function pauseRefreshing(state = INITIAL_STATE, action) {
  switch (action.type) {
    case XA_PAUSE_REFRESHING: {
      return {
        ...state,
        pause: action.pause,
      };
    }
    default: {
      return state;
    }
  }
}
